export enum Roles {
  ADMIN = 'ADMIN',
  NO_PRICING = 'NOPRICING',
  NO_PRICING_NO_ORDERS = 'NOPRICING_NOORDERS',
  NO_ACCOUNTS = 'NOACCOUNTS'
}

export enum Groups {
  B2B_CUSTOMER_GROUP = 'b2bcustomergroup',
  B2B_ADMIN_GROUP = 'b2badmingroup',
  ASALEO_B2B_ADMIN_GROUP = 'asaleob2badmingroup',
  ASALEO_B2B_CUSTOMER_GROUP = 'asaleob2bcustomergroup',
  ASALEO_B2B_RESTRICTED_CUSTOMER_GROUP = 'asaleob2brestrictedcustomergroup',
  ASALEO_B2B_NO_ACCOUNTS_GROUP = 'asaleob2bnoaccountsgroup'
}

export const UserGroups = {
  ADMIN: [Groups.B2B_CUSTOMER_GROUP, Groups.B2B_ADMIN_GROUP, Groups.ASALEO_B2B_ADMIN_GROUP],
  NO_PRICING: [Groups.B2B_CUSTOMER_GROUP, Groups.ASALEO_B2B_CUSTOMER_GROUP],
  NO_PRICING_NO_ORDERS: [Groups.B2B_CUSTOMER_GROUP, Groups.ASALEO_B2B_RESTRICTED_CUSTOMER_GROUP],
  NO_ACCOUNTS: [Groups.B2B_CUSTOMER_GROUP, Groups.ASALEO_B2B_NO_ACCOUNTS_GROUP]
}
